import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const NotFound = styled(Typography.Body)`
  width: 100%;
  text-align: center;
  padding-top: 50px;
  padding-bottom: 50px;
  color: ${({ theme }) => theme.palette.secondary.labels};
`;
